"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6471],{

/***/ 51827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41964);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58738);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11220);







var loggedItems = new Set();
var useAb = function(name) {
    var _abTests_name;
    var abTests = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useAbFt */ .S)().abTests;
    var value = (_abTests_name = abTests[name]) === null || _abTests_name === void 0 ? void 0 : _abTests_name.value;
    if (true) {
        if (typeof value === "undefined" && !loggedItems.has(name)) {
            loggedItems.add(name);
            logger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.warn('AbTest "%s" is not defined', name);
        }
    }
    return value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useAb);


/***/ }),

/***/ 4469:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);



// helps to combine local ref and forwardedOne
var useCombinedRefs = function(refs) {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(instance) {
        refs.forEach(function(ref) {
            if (!ref) {
                return;
            }
            if (typeof ref === "function") {
                return ref(instance);
            }
            ref.current = instance;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCombinedRefs);


/***/ }),

/***/ 53743:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59690);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86011);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45942);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61737);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50009);
/* harmony import */ var core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7547);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56690);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52983);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56376);
/* harmony import */ var date__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64895);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83913);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

















var getText = function(props) {
    var formatMessage = props.formatMessage, message = props.message, timeLeft = props.timeLeft, format = props.format;
    var values = message.values, rest = _object_without_properties(message, [
        "values"
    ]);
    var duration = date__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP.duration(timeLeft.current);
    var time = duration.format(format.replace("HH", "[".concat(Math.floor(duration.asHours()).toString().padStart(2, "0"), "]")).replace("S", "[".concat((duration.milliseconds() / 100).toFixed(0), "]")));
    return formatMessage(rest, _object_spread_props(_object_spread({}, values), {
        time: time
    }));
};
var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
var useCountdown = function(values) {
    var message = values.message, expiredMessage = values.expiredMessage, nodeRef = values.nodeRef, cookieName = values.cookieName, _values_format = values.format, format = _values_format === void 0 ? "mm:ss" : _values_format, _values_withMilliseconds = values.withMilliseconds, withMilliseconds = _values_withMilliseconds === void 0 ? false : _values_withMilliseconds, _values_initialTime = values.initialTime, initialTime = _values_initialTime === void 0 ? 20 * 60 * 1000 : _values_initialTime;
    var interval = withMilliseconds ? 100 : 1000;
    var intl = (0,intl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var timeLeft = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(0);
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(function() {
        var cookieTime = cookieName ? cookie_storage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.getItem(cookieName) : null;
        timeLeft.current = Number(cookieTime || initialTime);
        // ATTN save to force SSR and client sync, because cookie can be changed on the client side
        if (cookieTime && 0) {}
        return timeLeft.current <= interval;
    }), 2), isExpired = _useState[0], setExpired = _useState[1];
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        var cookieTime = cookieName ? cookie_storage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.getItem(cookieName) : null;
        timeLeft.current = Number(cookieTime || initialTime);
        setExpired(timeLeft.current <= interval);
    }, [
        cookieName,
        initialTime,
        interval
    ]);
    // ATTN layout effect is required to update node after react render
    useIsomorphicLayoutEffect(function() {
        if (!nodeRef || isExpired) {
            // You can not send a ref link if the timer is expired
            return;
        }
        var intervalId = null;
        var saveTicks = 0;
        var update = function() {
            if (nodeRef.current) {
                nodeRef.current.innerHTML = getText({
                    message: message,
                    timeLeft: timeLeft,
                    format: format,
                    formatMessage: intl.formatMessage
                });
            }
        };
        var tick = function() {
            timeLeft.current -= interval;
            if (timeLeft.current <= 0) {
                timeLeft.current = 0;
                clearInterval(intervalId);
                setExpired(true);
                cookie_storage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.setItem(cookieName, 0, {
                    maxAge: 24 * 60 * 60 * 1000
                });
                return;
            }
            if (cookieName) {
                if (saveTicks > 0) {
                    saveTicks--;
                } else {
                    cookie_storage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.setItem(cookieName, timeLeft.current, {
                        maxAge: 24 * 60 * 60 * 1000
                    });
                    // save each 5 seconds
                    saveTicks += 5 * 1000 / interval;
                }
            }
            update();
        };
        intervalId = setInterval(tick, interval);
        return function() {
            clearInterval(intervalId);
        };
    }, [
        cookieName,
        initialTime,
        format,
        interval,
        intl,
        isExpired,
        message,
        nodeRef
    ]);
    var countdownMessage = isExpired && expiredMessage ? intl.formatMessage(expiredMessage) : getText({
        message: message,
        timeLeft: timeLeft,
        format: format,
        formatMessage: intl.formatMessage
    });
    return {
        isExpired: isExpired,
        countdownMessage: countdownMessage
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCountdown);


/***/ }),

/***/ 15434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44204);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__);


var useDeepMemo = function(memoFn, deps) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (!ref.current || !fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(deps, ref.current.deps)) {
        ref.current = {
            deps: deps,
            value: memoFn()
        };
    }
    return ref.current.value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDeepMemo);


/***/ }),

/***/ 41501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


// return true if an offer is expired
var useExpiration = function(param) {
    var timeLeft = param.timeLeft, onExpired = param.onExpired;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!timeLeft || timeLeft <= 0), 2), isExpired = _useState[0], setExpired = _useState[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (timeLeft <= 0) {
            setExpired(true);
            return;
        }
        // it helps if state should be reset
        setExpired(false);
        // Max available timeout is 2 ** 31 - 1 or about 24.855 days
        var maxTimeout = Math.pow(2, 31) - 1;
        var timeout = setTimeout(function() {
            setExpired(true);
            if (typeof onExpired === "function") {
                onExpired();
            }
        }, Math.min(timeLeft, maxTimeout));
        return function() {
            clearTimeout(timeout);
        };
    }, [
        timeLeft,
        onExpired
    ]);
    return isExpired;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useExpiration);


/***/ }),

/***/ 19564:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50556);


var useFlow = function() {
    var _cookieStorage_getItem;
    var flowName = (_cookieStorage_getItem = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.flowName)) === null || _cookieStorage_getItem === void 0 ? void 0 : _cookieStorage_getItem.toLowerCase();
    var utmMedium = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.utmMediumBeforeSubscription);
    var utmSource = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.utmSourceBeforeSubscription);
    return {
        isCoFlow: flowName === "coflow",
        isOrgFlow: flowName === "orgflow",
        isEmailFlow: utmSource === "email",
        isFacebookFlow: flowName === "facebookflow",
        isInfluencerFlow: utmMedium === "influencer" || utmSource === "youtube",
        isOrganicFlow: !utmSource
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFlow);


/***/ }),

/***/ 75384:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/*

  returns "forceUpdate" method to invoke rerender of component programmatically. This hook is a sugar to not write
  copycat of

  const [ _, setState ] = useState(0)

  setState((v) => ++v)


  Usage:

  const forceUpdate = useForceUpdate()

  const handleClick = useCallback(() => {
    // do something
    forceUpdate()
  }, [])

 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

var useForceUpdate = function() {
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), 2), state = _useState[0], setState = _useState[1];
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setState(function(v) {
            return v + 1;
        });
    }, []);
    return [
        state,
        forceUpdate
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useForceUpdate);


/***/ }),

/***/ 39770:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41647);




var getScrollBarWidth = function() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    // @ts-ignore
    outer.style.msOverflowStyle = "scrollbar" // needed for WinJS apps
    ;
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    outer.style.overflow = "scroll";
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
};
var getPageOffset = function() {
    // isCSS1Compat for old browsers support like IE < 9,
    // which do not have window.pageYOffset and window.scrollY
    // For more info check https://developer.mozilla.org/ru/docs/Web/API/Window/scrollY
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    var isSupportPageOffset = typeof window.pageXOffset !== "undefined";
    if (isSupportPageOffset) {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    }
    return {
        x: isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
        y: isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    };
};
var openedModalsCount = 0;
var savedOffsetTop = 0;
var useFreezeBodyScroll = function() {
    var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    var translateRoot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(offset) {
        // can't use transform, because it creates new fixed layer and breaks fixed elements
        document.getElementById("root").style.marginTop = offset ? "".concat(offset, "px") : null;
    }, []);
    var addStyles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var offsetTop = getPageOffset().y;
        document.body.classList.add("body-scroll-frozen");
        document.body.style.paddingRight = "".concat(getScrollBarWidth(), "px");
        if (isMobile && offsetTop > 0) {
            window.scrollTo(0, 0);
            translateRoot(-offsetTop);
            savedOffsetTop = offsetTop;
        }
    }, [
        isMobile,
        translateRoot
    ]);
    var removeStyles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        document.body.classList.remove("body-scroll-frozen");
        document.body.style.paddingRight = "0px";
        if (isMobile && savedOffsetTop > 0) {
            translateRoot(0);
            window.scrollTo(0, savedOffsetTop);
            savedOffsetTop = 0;
        }
    }, [
        isMobile,
        translateRoot
    ]);
    (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        if (enabled) {
            if (openedModalsCount === 0) {
                addStyles();
            }
            openedModalsCount++;
            return function() {
                openedModalsCount--;
                if (openedModalsCount === 0) {
                    removeStyles();
                }
            };
        }
    }, [
        addStyles,
        removeStyles,
        enabled
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFreezeBodyScroll);


/***/ }),

/***/ 68426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41964);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58738);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11220);







var loggedItems = new Set();
var useFt = function(name) {
    var features = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useAbFt */ .S)().features;
    if (!name) {
        return;
    }
    var value = features[name];
    if (true) {
        if (typeof value === "undefined" && !loggedItems.has(name)) {
            loggedItems.add(name);
            logger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.warn('Feature "%s" is not defined', name);
        }
    }
    return value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFt);


/***/ }),

/***/ 30642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68471);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86011);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var containers_App_components_GlobalLoaderProvider_GlobalLoaderProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48145);




var useGlobalLoader = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(containers_App_components_GlobalLoaderProvider_GlobalLoaderProvider__WEBPACK_IMPORTED_MODULE_3__/* .GlobalLoaderContext */ .a);
    if (!context) {
        throw new Error("useGlobalLoader must be used within a GlobalLoaderProvider");
    }
    return context;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useGlobalLoader);


/***/ }),

/***/ 41647:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 69201:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53168);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83913);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55222);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84584);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89025);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7138);
/* harmony import */ var _useOnce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21058);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}












var cookiesToDelete = [
    helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.country,
    helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.discountCoupon,
    helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.appliedCouponCode,
    helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon
];
var useLandingSetup = function(param) {
    var couponCode = param.couponCode, cookies = param.cookies, _param_country = param.country, country = _param_country === void 0 ? "US" : _param_country, skip = param.skip;
    var pathname = (0,router__WEBPACK_IMPORTED_MODULE_6__/* .usePathname */ .jD)();
    var search = (0,router__WEBPACK_IMPORTED_MODULE_6__/* .useSearch */ .Rx)();
    var subscribeOffer = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_7__/* .useSubscribeOffer */ .Hu)();
    var forceUpdate = subscribeOffer.forceUpdate;
    (0,_useOnce__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        if (skip) {
            return;
        }
        cookiesToDelete.forEach(function(cookieName) {
            cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.removeItem(cookieName);
        });
        if (cookies) {
            Object.entries(cookies).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setSessionItem(key, value);
            });
        }
        if (couponCode !== undefined) {
            cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.discountCoupon, couponCode);
            if (couponCode === "FREE_TRIAL") {
                cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon, true);
            }
        }
        cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl, "".concat(pathname).concat(search));
        cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.country, country);
        if (true) {
            local_storage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.localStorageNames.shippingFormValues, {
                country: country
            });
            // force update if offer is changed
            setTimeout(function() {
                forceUpdate();
            });
        }
        var referrerLandingPageURL = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(pathname);
        cookie_storage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP.setItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.referrerLandingPageURL, referrerLandingPageURL, {
            sameSite: "None"
        });
    }, [
        skip,
        couponCode,
        country
    ]);
    return subscribeOffer;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLandingSetup);


/***/ }),

/***/ 21058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// if you want to execute a function only once, use can use this hook
var useOnce = function(callback) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    callbackRef.current = callback;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        callbackRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOnce);


/***/ }),

/***/ 31059:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

var useReducerState = function(initialState) {
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), 2), state = _useState[0], _setState = _useState[1];
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(value) {
        return _setState(function(prevState) {
            var newState = value;
            if (typeof value === "function") {
                newState = value(prevState);
            }
            return _object_spread({}, prevState, newState);
        });
    }, []);
    return [
        state,
        setState
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useReducerState);


/***/ }),

/***/ 18478:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

// This functionality is needed to properly hide forms or other elements during server rendering.
// Since we are using hydrate(), the client's render must match the one that came from the SSR.
// https://reactjs.org/docs/react-dom.html#hydrate
var useSSR = function() {
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), 2), isSSR = _useState[0], setSSR = _useState[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setSSR(false);
    }, []);
    return isSSR;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSSR);


/***/ }),

/***/ 71306:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export clearLoadedScripts */
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97334);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52983);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58738);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}









var loadedScripts = {};
// ATTN for tests usage only!
var clearLoadedScripts = function() {
    return loadedScripts = {};
};
var loadScript = function(src) {
    var async = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (loadedScripts[src] === true) {
        return Promise.resolve();
    }
    if (loadedScripts[src]) {
        return loadedScripts[src];
    }
    loadedScripts[src] = new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        script.async = async;
        script.type = "text/javascript";
        script.src = src;
        script.onerror = function(error) {
            logger__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.error(error, 'Script "%s" load error', src);
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(error);
        };
        script.onload = function() {
            logger__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.info('Script "%s" loaded', src);
            resolve();
            // required for setting correct status of "isLoaded" when the hook is rendered first time.
            loadedScripts[src] = true;
        };
        document.head.appendChild(script);
    });
    return loadedScripts[src];
};
var loadScriptsSerially = function() {
    var _ref = _async_to_generator(function(srcs, async) {
        var i;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < srcs.length)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        loadScript(srcs[i], async)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadScriptsSerially(srcs, async) {
        return _ref.apply(this, arguments);
    };
}();
var useScriptsLoader = function(srcs, opts) {
    var _ref = opts || {}, async = _ref.async, serial = _ref.serial, skip = _ref.skip;
    var isLoaded = srcs.every(function(src) {
        return loadedScripts[src] === true // need to check exactly for "true" value because value can be an unresolved Promise
        ;
    });
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
        isLoading: !isLoaded,
        error: null
    }), 2), state = _useState[0], setState = _useState[1];
    var isLoading = state.isLoading, error = state.error;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (isLoaded || skip) {
            return;
        }
        var isMounted = true;
        var promise;
        if (serial) {
            promise = loadScriptsSerially(srcs, async);
        } else {
            promise = Promise.all(srcs.map(function(src) {
                return loadScript(src, async);
            }));
        }
        promise.then(function() {
            if (isMounted) {
                setState({
                    isLoading: false,
                    error: null
                });
            }
        })["catch"](function(err) {
            if (isMounted) {
                setState({
                    isLoading: false,
                    error: err
                });
            }
        });
        return function() {
            isMounted = false;
        };
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return {
        isScriptLoading: isLoading,
        scriptLoadingError: error,
        isScriptLoaded: !isLoading && !error
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScriptsLoader);


/***/ }),

/***/ 6163:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


// TODO: use this hook for landing page
var useScrollingFrame = function(param) {
    var horizontalOffset = param.horizontalOffset, inverted = param.inverted, isVisible = param.isVisible, verticalOffset = param.verticalOffset;
    var frameRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isVisible) {
            return;
        }
        var animationFrameId;
        var scrollTop;
        var blockRect;
        var block = frameRef.current;
        var frame = function() {
            var blockOffsetTop = blockRect.top + scrollTop;
            var scrollWidth = blockRect.width - window.innerWidth + horizontalOffset * 2;
            var scrollHeight = (blockOffsetTop < window.innerHeight ? blockOffsetTop : window.innerHeight) - verticalOffset;
            animationFrameId = null;
            if (blockRect.top <= verticalOffset) {
                block.style.transform = "translateX(".concat(inverted ? 0 : -scrollWidth, "px)");
                return;
            }
            if (blockRect.top >= scrollHeight) {
                block.style.transform = "translateX(".concat(inverted ? -scrollWidth : 0, "px)");
                return;
            }
            var percent = scrollTop / scrollHeight;
            var value = scrollWidth * percent;
            block.style.transform = "translateX(".concat(inverted ? value - scrollWidth : -value, "px)");
        };
        var handleScroll = function() {
            scrollTop = window.scrollY;
            blockRect = block.getBoundingClientRect();
            if (animationFrameId) {
                return;
            }
            animationFrameId = requestAnimationFrame(frame);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll();
        return function() {
            window.removeEventListener("scroll", handleScroll);
            cancelAnimationFrame(animationFrameId);
        };
    }, [
        horizontalOffset,
        inverted,
        isVisible,
        verticalOffset
    ]);
    return frameRef;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScrollingFrame);


/***/ }),

/***/ 29555:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57719);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


var checkTriggerRect = function(triggerRect, triggerFirePosition) {
    if (triggerFirePosition === "top-height") {
        return triggerRect.top <= window.innerHeight;
    }
    // top-0 is default
    return triggerRect.top < 0;
};
var useStickyBeforeFooter = function(param) {
    var skip = param.skip, minimalScrollOffset = param.minimalScrollOffset, _param_triggerFirePosition = param.triggerFirePosition, triggerFirePosition = _param_triggerFirePosition === void 0 ? "top-0" : _param_triggerFirePosition, triggerRef = param.triggerRef;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isVisible = _useState[0], setVisibility = _useState[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (skip) {
            return;
        }
        var prevIsVisible = false;
        var isOffsetWay = typeof minimalScrollOffset === "number" && minimalScrollOffset >= 0;
        var handleScroll = (0,throttle_debounce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            try {
                var _document_getElementById;
                if (!isOffsetWay && !triggerRef.current) {
                    return;
                }
                var isTopTriggerFired = isOffsetWay ? window.scrollY >= minimalScrollOffset : checkTriggerRect(triggerRef.current.getBoundingClientRect(), triggerFirePosition);
                // hide when footer is visible
                var isFooterVisible = ((_document_getElementById = document.getElementById("footer")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.getBoundingClientRect().top) < window.innerHeight;
                var isVisible = isTopTriggerFired && !isFooterVisible;
                if (isVisible !== prevIsVisible) {
                    setVisibility(isVisible);
                    prevIsVisible = isVisible;
                }
            } catch (error) {
                console.error(error);
            }
        }, 200);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll();
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        skip,
        triggerRef,
        triggerFirePosition,
        minimalScrollOffset
    ]);
    return isVisible;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStickyBeforeFooter);


/***/ }),

/***/ 8165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47361);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73302);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99214);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}



var useStickyBetween = function(param) {
    var bottomObserverProps = param.bottomObserverProps, _param_onlyMobile = param.onlyMobile, onlyMobile = _param_onlyMobile === void 0 ? true : _param_onlyMobile, stickyClass = param.stickyClass, topObserverProps = param.topObserverProps;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().isMobile;
    var _useSticky = _sliced_to_array((0,intersection_observer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        stickyClass: stickyClass
    }), 3), containerRef = _useSticky[0], stickyElementRef = _useSticky[1], setSticky = _useSticky[2];
    var _useEntry = _sliced_to_array((0,intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        observerProps: topObserverProps
    }), 4), topTriggerRef = _useEntry[0], topEntry = _useEntry[1], unobserveTop = _useEntry[2], refreshTop = _useEntry[3];
    var _useEntry1 = _sliced_to_array((0,intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        observerProps: bottomObserverProps
    }), 4), bottomTriggerRef = _useEntry1[0], bottomEntry = _useEntry1[1], unobserveBottom = _useEntry1[2], refreshBottom = _useEntry1[3];
    var refresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        refreshTop();
        refreshBottom();
    }, [
        refreshTop,
        refreshBottom
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!topEntry || !bottomEntry) {
            return;
        }
        if (onlyMobile && !isMobile) {
            return;
        }
        if (topEntry.isIntersecting) {
            return setSticky(true);
        }
        if (bottomEntry.isIntersecting) {
            return setSticky(false);
        }
        var windowInnerHeight = window.innerHeight;
        return setSticky(topEntry.boundingClientRect.top < windowInnerHeight && bottomEntry.boundingClientRect.top > windowInnerHeight);
    }, [
        bottomEntry,
        isMobile,
        onlyMobile,
        setSticky,
        topEntry
    ]);
    return [
        containerRef,
        stickyElementRef,
        topTriggerRef,
        bottomTriggerRef,
        setSticky,
        refresh
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStickyBetween);


/***/ }),

/***/ 65021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


var useUniqueId = function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(prefix).concat((0,react__WEBPACK_IMPORTED_MODULE_1__.useId)());
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUniqueId);


/***/ })

}]);